import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { floors } from './floorData';
export function FloorsSection() {
  const [activeId, setActiveId] = useState(floors[0].id);
  const active = floors.find(f => f.id === activeId) ?? floors[0];
  return <section className="w-full py-14 md:py-32 bg-bg-light relative z-10" data-id="element-62">
      <div className="px-6 md:px-14" data-id="element-63">
        <div className="max-w-7xl mx-auto" data-id="element-64">
          {/* Header + tabs */}
          <header className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8 md:mb-12" data-id="element-65">
            <div data-id="element-66">
              <p className="text-xs tracking-widest text-text-muted font-light mb-3 uppercase" data-id="element-67">
                Floor Areas
              </p>
              <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight text-primary leading-tight" data-id="element-68">
                Explore each level
              </h2>
            </div>

            {/* Tabs */}
            <div role="tablist" aria-label="Select a floor" className="flex items-center gap-6 md:gap-8" data-id="element-69">
              {floors.map(floor => <button key={floor.id} role="tab" aria-selected={activeId === floor.id} onClick={() => setActiveId(floor.id)} className="group/tab relative pb-2 text-base md:text-lg font-light transition-colors" data-id="element-70">
                  <span className={activeId === floor.id ? 'text-primary' : 'text-text-muted'} data-id="element-71">
                    {floor.tab}
                  </span>
                  <span className={`absolute left-0 -bottom-px h-px bg-accent transition-all duration-500 ease-out ${activeId === floor.id ? 'w-full' : 'w-0 group-hover/tab:w-1/2'}`} data-id="element-72" />
                </button>)}
            </div>
          </header>

          {/* Plan image + inline breakdown */}
          <AnimatePresence mode="wait" data-id="element-73">
            <motion.div key={active.id} initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -12
          }} transition={{
            duration: 0.6,
            ease: [0.16, 1, 0.3, 1]
          }} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start" data-id="element-74">
              {/* Plan image */}
              <div className="lg:col-span-7" data-id="element-75">
                <img src={active.planImage} alt={`${active.planLabel} — labeled layout of ${active.title}`} className="w-full h-auto object-contain" data-id="element-76" />
              </div>

              {/* Breakdown */}
              <div className="lg:col-span-5" data-id="element-77">
                {/* Compact total + ceiling */}
                <div className="flex items-baseline justify-between gap-6 pb-5 border-b border-black/10" data-id="element-78">
                  <div data-id="element-79">
                    <h3 className="font-heading text-xl md:text-2xl font-light tracking-tight text-primary leading-tight" data-id="element-80">
                      {active.title}
                    </h3>
                    <p className="mt-1 text-2xl md:text-3xl font-light text-accent tracking-tight leading-none" data-id="element-81">
                      {active.area}
                    </p>
                  </div>
                  <div className="text-right shrink-0" data-id="element-82">
                    <p className="text-[0.7rem] tracking-widest text-text-muted font-light uppercase" data-id="element-83">
                      Ceiling
                    </p>
                    <p className="mt-1 text-lg md:text-xl font-light text-primary" data-id="element-84">
                      {active.ceilingHeight}
                    </p>
                  </div>
                </div>

                {/* Room rows */}
                <dl className="mt-5 space-y-0" data-id="element-85">
                  {active.rows.map(row => <div key={row.label} className="flex items-baseline justify-between gap-6 border-b border-black/5 py-2.5" data-id="element-86">
                      <dt className="tracking-wide text-sm font-light text-text-muted leading-snug" data-id="element-87">
                        {row.label}
                      </dt>
                      <dd className="whitespace-nowrap text-sm font-light text-primary" data-id="element-88">
                        {row.value}
                      </dd>
                    </div>)}
                </dl>

                {active.footnote && <p className="mt-5 text-xs tracking-wide font-light text-text-muted" data-id="element-89">
                    {active.footnote}
                  </p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}